<template>
  <div>
    <div class="logo-search">
      <h1 class="logo">
        <a class="logoImg" :href="url" :style="logoPos"></a>
      </h1>
      <city-mask :hotKeyWords="hotKeyWords"></city-mask>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CityMask from './Citymask'
export default {
  name: 'Logotitle',
  components: {
    CityMask
  },
  props: {
    hotKeyWords: Array,
    url: String,
    logoPos: String
  },
  data () {
    return {
      hotKeyWordsList: [],
      phoneNum: '',
      searchVal: '',
      hotSearchKeyword: {}
    }
  },
  computed: {
    cityId () {
      return this.soukecityId
    },
    ...mapState(['soukecityId', 'cityName'])
  },
  methods: {
    soukechId () {
      window.open(`http://souke1.xdf.cn/Search.aspx?cid=${this.cityId}&kw=${this.searchVal}`)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.logo-search
  width: $defaultwidth
  height: 112px
  margin: $defaultmargin
  font-size: 14px
  vertically()
  .logo
    vertically()
    .logoImg
      height: 58px
      width: 210px
      background: url(http://file.xdf.cn/neworiental/images/newlogo.png) no-repeat
      text-align: center
      vertically()
  div
    flex: 1
  .quick_teaching
    color: #31A893
    display: block
    width: 98px
    height: 33px
    line-height: 33px
    margin-left: 10px
    border: 1px solid #CBE9E9
    background: #E2F8F7
    float: right
    font: 18px/35px '微软雅黑'
    cursor: pointer
    text-align: center
    margin-top: -2px
</style>



// WEBPACK FOOTER //
// src/common-components/Logotitle.vue